/**
 * True when running in the packaged or dev Electron client (file:// or preload bridge).
 */
export function isElectronClient() {
  return (
    typeof window !== 'undefined' &&
    (window.location.protocol === 'file:' || window.electron !== undefined)
  );
}
